var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_outward_FILL0_wght400_GRAD0_opsz48 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.13335 11.8997L3.43335 11.1997L10.3 4.33301H4.00002V3.33301H12V11.333H11V5.03301L4.13335 11.8997Z",
    fill: "#DE2C3C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNegative);
export default __webpack_public_path__ + "static/media/arrow-negative.24bcb8ed4afb96a19459488bea8aacee.svg";
export { ForwardRef as ReactComponent };